import { toast } from 'sonner';

/**
 * Sentinel error code returned by enrichment edge functions when the caller
 * is the demo account. Matches the constant in
 * supabase/functions/_shared/demo-utils.ts.
 *
 * Used to swap any third-party enrichment failure for a friendly "sign up
 * to use this on your real data" toast, without scattering demo checks
 * across every mutation hook.
 */
export const ENRICHMENT_DISABLED_IN_DEMO = 'ENRICHMENT_DISABLED_IN_DEMO';

const FRIENDLY_MESSAGE =
  'External data lookup is a paid feature — sign up to use it on your real contacts.';

export class EnrichmentBlockedError extends Error {
  readonly code = ENRICHMENT_DISABLED_IN_DEMO;
  constructor() {
    super(FRIENDLY_MESSAGE);
    this.name = 'EnrichmentBlockedError';
  }
}

export function isEnrichmentBlockedError(err: unknown): boolean {
  if (!err) return false;
  if (err instanceof EnrichmentBlockedError) return true;
  if (err instanceof Error) {
    return err.message === ENRICHMENT_DISABLED_IN_DEMO ||
      err.message === FRIENDLY_MESSAGE ||
      (err as { code?: string }).code === ENRICHMENT_DISABLED_IN_DEMO;
  }
  if (typeof err === 'string') return err === ENRICHMENT_DISABLED_IN_DEMO;
  return false;
}

let lastShownAt = 0;

export function showEnrichmentBlockedToast(): void {
  const now = Date.now();
  if (now - lastShownAt < 1500) return;
  lastShownAt = now;
  toast.info(FRIENDLY_MESSAGE);
}
